exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".liveaboard-nav-button[data-v-d66e1774]:disabled{background-color:var(--black-light-1)}@media(max-width:600px){.trip-separator[data-v-d66e1774]{height:16px;background-color:#f6f6f6;border:0}.yacht-itinerary-list li:last-of-type hr[data-v-d66e1774]{display:none}.itinerary-list-header[data-v-d66e1774]{padding-top:24px;padding-bottom:24px;align-items:flex-start;height:auto}.liveaboard-nav-button[data-v-d66e1774]{border:1px solid #dcdcdc}}", ""]);

// exports
